import React from 'react';
import * as Yup from 'yup';
import { Formik } from 'formik';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { signInRequest } from '~/store/modules/auth/actions';

export default function FormConfig({
  children,
  captchaValue,
  setCaptchaError,
}) {
  const { t } = useTranslation();

  const dispatch = useDispatch();
  return (
    <Formik
      initialValues={{
        email: '',
        password: '',
        code: '',
      }}
      onSubmit={(values, { setSubmitting }) => {
        const captchaIsFilled = captchaValue !== null;
        if (captchaIsFilled) {
          // Form data will be sent here
          dispatch(
            signInRequest({ ...values, 'g-recaptcha-response': captchaValue })
          );
        } else {
          setCaptchaError(t('captchaIsRequiredValidationError'));
        }

        setSubmitting(false);
      }}
      validationSchema={Yup.object().shape({
        email: Yup.string()
          .email(t('invalidEmail'))
          .required(t('emailIsRequired')),
        password: Yup.string().required(t('passwordIsRequired')),
        code: Yup.string().required(t('smsCodeValidationError')),
      })}
    >
      {children}
    </Formik>
  );
}

FormConfig.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.func]).isRequired,
  captchaValue: PropTypes.string,
  setCaptchaError: PropTypes.func,
};

FormConfig.defaultProps = {
  captchaValue: null,
  setCaptchaError: () => {},
};
